import { render, staticRenderFns } from "./PortableRadiography.vue?vue&type=template&id=3d6a80fe&"
import script from "./PortableRadiography.vue?vue&type=script&lang=js&"
export * from "./PortableRadiography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports